export default __webpack_public_path__ + "static/media/work-learn.holistic-nutrition.08d1c656.jpg";